<template>
    <div class="text-center">
        <v-btn v-if="file !== null" small icon @click="showFileDialog(file)">
            <v-icon small color="success">mdi-file-find</v-icon>
        </v-btn>
        <v-btn v-if="file !== null && !!showAdminUI" small icon @click="deletePhoto">
            <v-icon small color="error">mdi-close</v-icon>
        </v-btn>
        <v-btn small icon @click="changePhoto" v-if="!!showAdminUI">
            <v-icon small>mdi-dots-horizontal</v-icon>
        </v-btn>
        <img style="display: none;" v-for="src in imageView" :src="src" :key="src">
        <v-dialog v-model="selectFileDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Выберите файл</span>
                </v-card-title>
                <v-card-text height="300px">
                    <v-container>
                        <v-row>
                            <v-col cols="4" v-for="(image, index) in images" :key="index">
                                    <v-img :aspect-ratio="1" :src="(image.file.indexOf('https://fit-service-bitrix.ru') > -1) ? image.file : `https://sbotapi.fitauto.ru/v15/shopper/viewfile/${image.small_file || image.file}`" contain @click="setFile(image.file)">
                                        <template v-slot:placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate color="orange"></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="selectFileDialog = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  export default {
    name: 'fileSelector',
    props: ['value', 'images', 'mode'],
    data() {
      return {
        showFile: false,
        file: this.value,
        selectFileDialog: false,
        options: {
          loop: false,
          fullscreen: false,
          inline: false,
          button: false,
          navbar: false,
          title: false,
          toolbar: true,
          tooltip: false,
          movable: true,
          zoomable: true,
          rotatable: true,
          scalable: false,
          transition: false,
          keyboard: true,
        }
      }
    },
    computed: {
      showAdminUI() {
        if(this.mode) {
          return this.mode === 'manager'
        } else {
          return true
        }
      },
      imageView() {
        if(this.imageSource === '') {
          return []
        }
        return [this.imageSource]
      },
      imageSource() {
        if(this.file !== null) return (this.file.indexOf('https://fit-service-bitrix.ru') > -1) ? this.file : `https://sbotapi.fitauto.ru/v15/shopper/viewfile/${this.file}`
        return ''
      },
    },
    methods: {
      setFile(newFile) {
        this.file = newFile
        this.selectFileDialog = false
        this.showFile = false
        this.$emit('input', this.file)
        this.$nextTick(function () {
          this.$emit('change')
        })
      },
      changePhoto() {
        this.selectFileDialog = true
        this.$emit('input', this.file)
        this.$nextTick(function () {
          this.$emit('change')
        })
      },
      deletePhoto () {
        this.file = null
        this.$emit('input', this.file)
        this.$nextTick(function () {
          this.$emit('change')
        })
      },
      showFileDialog (file) {

        console.log(file, this.imageView);

        // const index = this.images.findIndex(f => f.file === file);

        // this.$viewer.show()
        this.$viewerApi({
          images: this.imageView,
          options: {
            ...this.options,
            // initialViewIndex: index > -1 ? index : 0,
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
